export const formatPublicPrice = (value) => `$${Number(value).toFixed(2)}`;

export const getLowestPublicPrice = (products = [], medicationType) => {
  const normalizedType = String(medicationType || '').toLowerCase();
  const prices = products
    .filter(product => String(product?.product_name || '').toLowerCase().includes(normalizedType))
    .map(product => Number(product?.price))
    .filter(Number.isFinite);

  return prices.length ? Math.min(...prices) : null;
};

// Lowest price per product_name, driven entirely by whatever products the
// pricing list contains — no fixed set of expected product names.
export const getStartingPricesByProduct = (products = []) => {
  const lowestByProduct = new Map();

  products.forEach(product => {
    const name = product?.product_name;
    const price = Number(product?.price);
    if (!name || !Number.isFinite(price)) return;

    const current = lowestByProduct.get(name);
    if (current === undefined || price < current) {
      lowestByProduct.set(name, price);
    }
  });

  return Array.from(lowestByProduct, ([product_name, price]) => ({ product_name, price }));
};
